export const shouldCloseMobileSidebar = (width, collapsed, target) => {
  if (width > 991 || collapsed) return false;
  return !target?.closest?.('.ant-layout-sider, [data-sidebar-toggle], .ant-menu-submenu-popup');
};
